<template>
  <page-status class="eproposal-index" :loading="loading">
    <div class="tooltips">
      <div class="icon">
        <img
          src="http://i3.cathay-ins.com.cn/prod/posts/1ccbd6931aa2a45c29fdbc5ff34e1357.png"
          alt="notice"
        />
      </div>
      <div class="text">请阅读至页面底部，待按钮亮起后完成确认</div>
    </div>
    <div
      :style="{ overflowY: 'scroll', padding: '24px', height: '85vh' }"
      class="none-a imgwh100"
      @scroll="handleScroll"
    >
      <h3>车险合规经营承诺书</h3>

      <p>
        为充分满足首都消费者保险保障需求，切实维护消费者合法权益，提升行业车险服务水平，树立行业良好形象，国泰产险北京分公司郑重承诺：
      </p>
      <p>
        1.严格遵守国家法律、法规，执行国家金融监督管理总局等监督管理部门有关规定，认真履行保险合同中各项约定，不损害社会公共利益，不侵害投保人、被保险人的合法权益。
      </p>
      <p>
        2.正面引导消费者了解自身权利义务，维护消费者合法权益，切实履行保险人法定提示、说明义务，并做好说明、询问与告知的书面确认工作。
      </p>
      <p>
        3.本公司及其合作机构工作人员不得通过返还或赠送现金、预付卡、有价证券等方式，给予或者承诺给予投保人、被保险人保险合同约定以外的利益。
      </p>
      <p>
        4.始终以做好保险消费者服务作为首要目标，努力提高保险行业的服务能力，切实维护保险消费者合法权益，采取有效措施，为广大保险消费者提供更优质的保险保障服务，提升保险消费者获得感。
      </p>
      <p>
        本合规经营承诺书自公布之日起生效，接受社会监督，本公司服务监督电话010-59336888。如有相关违规证据材料，也可向北京保险行业车险监督邮箱（bjhycxjd@126.com）反映情况。
      </p>
    </div>
    <div class="bottom-button">
      <van-button
        :disabled="isClick"
        class="button"
        type="info"
        @click="readed()"
      >
        下一步
      </van-button>
    </div>
  </page-status>
</template>

<script>
import PageStatus from '@/components/PageStatus';
import { Toast } from 'vant';
import * as services from '@/services';

export default {
  components: {
    PageStatus,
  },

  data() {
    return {
      loading: false,
      isClick: true,
      content: '',
    };
  },
  mounted() {
    this.checkIfScrollable();
  },

  methods: {
    checkIfScrollable() {
      const element = document.querySelector('.imgwh100');
      if (element && element.scrollHeight <= element.clientHeight) {
        // 如果内容高度小于等于容器高度，则不需要滚动
        this.isClick = false;
      }
    },
    readed() {
      const { businessNo, code, newEnergyFlag, lawfulFlag } = this.$route.query;
      //北京新能源跳转
      if (newEnergyFlag === '1') {
        this.$router.push({ path: '/new-energy', query: this.$route.query });
        return;
      }
      this.fetchData();
    },
    fetchData() {
      const { businessNo, code } = this.$route.query;
      services
        .eproposalShift(businessNo)
        .then(res => {
          const { content } = res;
          if (content) {
            const newUrl = code ? `${content}&code=${code}` : content;
            window.location.replace(newUrl);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleScroll(event) {
      const element = event.target;

      // 判断是否滚动到底部
      if (
        Math.abs(
          element.scrollHeight - element.scrollTop - element.clientHeight,
        ) < 1
      ) {
        this.isClick = false;
      }
    },
  },
};
</script>

<style lang="less">
.tooltips {
  background-color: #fff9ed;
  width: 718px;
  padding: 0 16px;
  height: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  .icon {
    width: 20px;
    height: 20px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .text {
    font-size: 14px;
    color: #ff6010;
    margin-left: 10px;
  }
  .clause-name {
    img {
      width: 20px;
    }
  }
}
.new-energy {
  height: 100vh;
  overflow-y: scroll;
  img {
    width: 100%;
    margin-bottom: 50px;
  }
}
.bottom-button {
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
  .button {
    width: 100%;
    flex: 1;
    border-radius: 4px;

    & + .button {
      margin-left: 12px;
    }
  }
}
</style>
